<template>
    <div class="clock-app settings">
        <div class="mt-3">
            <autoCompleteComponent :getValue="getTimeZone" placeholder="Search For Address"></autoCompleteComponent>
        </div>
        <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Font Color
                    </label>

                    <input type="color" @input="onColorChange($event)" name="color"  class="custonInput" :value="color" /> 
                </div> 
            </div>
        </div> 
        <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left  !mb-0 !text-2xs">
                    24 HOUR FORMAT
                </label>
                <Switches theme="bootstrap" v-model="fullformat" color="success" ></Switches>

            </div> 
        </div>
        <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    SHOW SECONDS
                </label>
                <Switches theme="bootstrap" v-model="showSeconds" color="success" ></Switches>
            </div> 
        </div>
       
    </div>
</template>
<script>
import Switches from 'vue-switches';
import autoCompleteComponent from "../../../utils/AutoComplete.vue";
export default { 
 name:"ClockAppSettings",
 components:{
    Switches,
    autoCompleteComponent
 },
 data(){
    return{
        fullformat:false,
        showSeconds:false,
        color:"#000"
    }
 },
 
 watch:{
    "$store.state.activeObjectprops" : {
            handler(updatedValues) {
              
                this.showSeconds = updatedValues?.showSeconds;
                this.fullformat = updatedValues?.format === "24" ? true : false;
                this.color = updatedValues?.color;
            },
            deep: true,
            immediate: true

        },
    fullformat(value){
        console.log("fullformate:" + value);
        this.changeFormat(value)
    },
    showSeconds(value){
        console.log("showSeconds:" + value);
        this.changeShowSeconds(value)
    }
 },
 methods:{
    getTimeZone(value){
        this.$store.dispatch("setCurrentObjectProperties", {  timezone: value.timezone ? value.timezone : "" });
       
    },
    changeFormat(value){
        this.$store.dispatch("setCurrentObjectProperties", { format: value == true  ? "24" : "12" });
    },
    changeShowSeconds(value){
        this.$store.dispatch("setCurrentObjectProperties", { showSeconds: value });
    },
    onColorChange(e){
            this.$store.dispatch("setCurrentObjectProperties" , { color:  e.target.value })
        },
 }
}
</script>